module.exports = __webpack_public_path__ + "img/rob_qiangci.2118dc9e.png";